import { render, staticRenderFns } from "./zone-bid-announcement.vue?vue&type=template&id=04c06dca&scoped=true"
import script from "./zone-bid-announcement.vue?vue&type=script&lang=js"
export * from "./zone-bid-announcement.vue?vue&type=script&lang=js"
import style0 from "./zone-bid-announcement.vue?vue&type=style&index=0&id=04c06dca&prod&lang=css"
import style1 from "./zone-bid-announcement.vue?vue&type=style&index=1&id=04c06dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c06dca",
  null
  
)

export default component.exports